/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Loader from "material/loader/loader";
import UnsavedMessage from 'material/message/popup/unsaved/unsaved_container';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/link/link_styles';



/* ========== ~~~~~~~~~~ LINK : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const Link = (props) => {
    const handleOperationText = () => {
        switch (props.operation) {
            case 'save':
                return `Saving ...`;
            case 'discard':
                return `Discarding ...`;
            case 'delete':
                return `Deleting ...`;
            case 'create':
                return `Creating ...`;
            case 'run':
                return `Running ...`;
            case 'download':
                return `Downloading ...`;
            case 'send':
                return `Sending ...`;
            case 'load':
            default:
                return `Loading ...`;
        }
    };
    const handleText = () => {
        return props.processing ? handleOperationText() : props.text;
    };
    const handleIcon = () => {
        return props.processing ? null : props.icon;
    };
    const handleClick = (e) => {
        // prevent default action on click
        e.preventDefault();
        // if we have a handler passed as a prop execute it (make sure this is FIRST to execute for things like state changes)
        if (props.handleClick) props.handleClick(e);
        // handle different link type cases
        switch (props.type) {
            case 'modal':
                props.action === false ?
                    props.displayModal(false)
                    :
                    props.displayModal(true, props.action)
                ;
                break;
            case 'custom':
                break;
            case 'email':
                window.open(props.action, '_self');
                break;
            case 'action':
                if (props.action) props.action();
                break;
            case 'action_route':
                if(props.editMode){
                    displayWarning(props.action);
                    return;
                }
                if (props.action) props.action();
                break;
            case 'scroll':
                // action = ref in this case
                // scroll to specific ref (DOM element)
                window.scrollTo(0, props.action.offsetTop);
                break;
            case 'external':
                if(props.editMode){
                    displayWarning(()=>window.open(props.action));
                    return;
                }
                window.open(props.action);
                break;
            case 'internal':
                if(props.editMode){
                    displayWarning(()=>props.moveToPage(props.action));
                    return;
                }
                props.moveToPage(props.action);
                break;
            default:
                break;
        }
    };
    const handleTarget = () => {
        switch (props.target) {
            case 'external':
                return '_blank';
            case 'internal':
            default:
                return '_self';
        }
    };
    const isActive = () => props.currentPage.includes(props.name) || props.currentPage.includes(props.action) ? true : false;
    // const displayActiveClass = () => props.type === 'internal' ? props.name === 'logout' || props.behavior === 'back'  ? `isActive-false` : `isActive-${isActive()}` : '';
    const displayActiveClass = () => {
        switch (props.type) {
            case 'internal':
                return props.name === 'logout' || props.behavior === 'back' ? `isActive-false` : `isActive-${isActive()}`;
            case 'scroll':
                return props.activeSection === props.name ? `isActive-true` : `isActive-false`; // section id and link name must match
            default:
                return '';
        }
    };
    const handleHREF = () => {
        switch (props.type) {
            case 'external':
            case 'email':
                return props.action;
            case 'internal':
                return props.action.substring(props.action.indexOf('/')).replace('/', ''); // removing division and slash so the preview of this from the browser looks correct
            default:
                return `#action-${props.name}`;
        }
    };

    const displayWarning = (action) => props.displayModal(true, <UnsavedMessage primaryAction={action} />);

    return (
        <span className={`link ${generateClasses(props, ['iconRight', 'iconOnly'])} disabled-${props.disabled} icon-${props.icon ? true : false} underline-${props.underline ? true : false} ${displayActiveClass()} processing-${props.processing} ${props.classes.link}`} onClick={handleClick}>
            <a href={handleHREF()} target={handleTarget()} title={props.title}>
                {props.icon || props.text ?
                    <span className={`inner`}>
                        {!props.removeLoaderIcon && <Loader />}
                        {handleIcon()}
                        <span className={`text`}>{handleText()}</span>
                    </span>
                    :
                    props.children
                }
            </a>
            {props.divider ? <span className={`divider`}>|</span> : null}
        </span>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Link);